import { render } from "./MySubject.vue?vue&type=template&id=17d6df20"
import script from "./MySubject.vue?vue&type=script&lang=js"
export * from "./MySubject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__